<glxy-form-field size="small">
  <glxy-label>{{ 'AUTOMATIONS.EDITOR.TASKS.DELAY_UNTIL_EVENT.WORKFLOW_STEP_SELECTOR' | translate }}</glxy-label>
  <mat-select
    [disabled]="disabled"
    [ngModel]="selectedWorkflowStepContainer"
    (ngModelChange)="onSelectedWorkflowStepContainerChange($event)"
    [compareWith]="isSameWorkflowStep"
  >
    <mat-option *ngFor="let c of workflowStepOptions" [value]="c">
      {{ c.workflowStep.name }}
    </mat-option>
  </mat-select>
</glxy-form-field>
<glxy-form-field size="small">
  <glxy-label>{{ 'AUTOMATIONS.EDITOR.TASKS.DELAY_UNTIL_EVENT.WORKFLOW_DATA_TYPE_SELECTOR' | translate }}</glxy-label>
  <mat-select [formControl]="selectedValuesFormControl" [compareWith]="compareSelectedValues">
    <mat-option
      *ngFor="let outputParam of outputParameterOptions"
      [value]="{ container: selectedWorkflowStepContainer, param: outputParam }"
    >
      {{ outputParam?.settings?.name }}
    </mat-option>
  </mat-select>
</glxy-form-field>
